<template>
  <div class="goods-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" />
    <MilkGoodsListComponent
      v-if="pageData"
      :page-data="pageData"
      @view="view"
      @edit="edit"
      @up="up"
      @down="down"
      @remove="remove"
      @onSelectChanged="onSelectChanged"
      @onPageChanged="onPageChanged"
    />
    <el-dialog :title="goodsData.id ? (goodsDialog.canEdit ? '修改商品' : '商品详情') : '新增商品'" :visible.sync="goodsDialog.showEditDialog" width="65%" @closed="hideGoodsEditDialog" :close-on-click-modal="false">
      <el-form :model="goodsData" :rules="rules" :disabled="!goodsDialog.canEdit">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">基本信息</span>
          </div>
          <div class="text item">
            <el-form-item label="名称" label-width="120px" prop="title">
              <el-col :span="20">
                <el-input type="text" v-model="goodsData.title" maxlength="50" show-word-limit></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="价格" prop="price" label-width="120px" v-if="false">
              <el-col :span="6">
                <el-input type="text" v-model="goodsData.price" @change="formatPrice">
                  <template slot="suffix">元</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="分类" prop="category" label-width="120px">
              <el-col :span="6">
                  <el-select v-model="goodsData.category" filterable placeholder="请选择">
                    <el-option label="请选择" :value="0"></el-option>
                    <el-option-group
                      v-for="item in categorys"
                      :key="item.id"
                      :label="item.title">
                      <el-option
                        v-for="i in item.children"
                        :key="i.id"
                        :label="i.title"
                        :value="i.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
              </el-col>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">商品图片</span>
          </div>
          <div class="text item">
            <el-form-item label="封面图片" label-width="120px" prop="cover">
              <el-upload
                accept="image/*"
                :class="'cover-uploader' + (coverImages.length > 0 ? ' disabled' : '')"
                action="/mgr/image/upload" list-type="picture-card"
                :on-exceed="uploadFileExceed"
                :file-list="coverImages"
                :on-success="handleCoverSuccess"
                :data="{type:'cover'}"
                :limit="1"
                :multiple="false"
                :auto-upload="true"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url">
                  <span class="el-upload-list__item-actions" v-if="goodsDialog.canEdit">
                <span class="el-upload-list__item-delete" @click="handleCoverRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="商品图片" label-width="120px" prop="images">
              <el-upload
                accept="image/*"
                :class="'detail-uploader' + (detailImages.length > 4 ? ' disabled' : '')"
                action="/mgr/image/upload"
                :on-exceed="uploadFileExceed"
                :file-list="showDetailImages"
                list-type="picture-card"
                :on-success="handleDetailSuccess"
                :data="{type:'scroll'}"
                :limit="5"
                :multiple="true"
                :auto-upload="true"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url">
                  <span class="el-upload-list__item-actions" v-if="goodsDialog.canEdit">
                <span class="el-upload-list__item-delete" @click="handleDetailRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">商品详情</span>
          </div>
          <div class="text item">
            <el-form-item prop="content">
              <Toolbar
                style="border: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                mode="default"
              />
              <Editor
                style="height: 300px; overflow-y: hidden; border: solid 1px #ccc; border-top: none"
                :defaultConfig="editorConfig"
                mode="default"
                @onCreated="onEditorCreate"
              />
            </el-form-item>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="goodsDialog.showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveGoods" v-if="goodsDialog.canEdit" :disabled="goodsDialog.disabled">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import Sortable from 'sortablejs'
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import MilkGoodsListComponent from '../../../components/goods/MilkGoodsListComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {MessageUtil} from '../../../utils/MessageUtil'

export default {
  name: 'MilkGoodsListPage',
  components: {
    MilkGoodsListComponent,
    OperationBoxComponent,
    Editor,
    Toolbar
  },
  mounted () {
    this.updateGoodsList()
    this.loadCategorys()
  },
  data () {
    let that = this
    let checkPrice = (rule, value, callback) => {
      value = parseFloat(value)
      if (isNaN(value)) {
        return callback(new Error('价格格式不正确'))
      }
      if (parseFloat(value) === 0) {
        return callback(new Error('价格必须大于0'))
      }
      if (parseFloat(value) <= 0) {
        return callback(new Error('价格输入不正确'))
      }
    }
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateGoodsList },
        { title: '新增商品', disabled: false, type: 'button', theme: 'primary', action: this.showGoodsEditDialog },
        { title: '上架', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'success', action: this.batchUp },
        { title: '下架', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'warning', action: this.batchDown },
        { title: '删除商品', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'danger', action: this.batchRemove },
        { title: '商品状态',
          type: 'select',
          action: this.onAuditStateChange,
          options: [
            { title: '全部', value: 0 },
            { title: '上架中', value: 1 },
            { title: '已下架', value: 2 }
          ]
        },
        {
          title: '商品分类',
          type: 'selectGroup',
          filterable: true,
          action: this.onCategoryChange,
          options: () => {
            let items = []
            for (let i in this.categorys) {
              let item = this.categorys[i]
              let children = []
              for (let j in item.children) {
                let child = item.children[j]
                children.push({
                  title: child.title,
                  value: child.id
                })
              }
              items.push({
                title: item.title,
                value: item.id,
                children: children
              })
            }

            return items
          }
        }
      ],
      filters: [{
        searchValue: '',
        type: 'title',
        title: '商品名称',
        options: [{
          title: '商品名称',
          value: 'title'
        }],
        action: this.onFilterChange
      }],
      rules: {
        title: [{
          required: true,
          message: '名称不能为空'
        }],
        price: [{
          required: true,
          validator: checkPrice
        }],
        cover: [{ required: true }],
        images: [{ required: true }],
        content: [{ required: true }]
      },
      categorys: [],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        category: 0,
        status: null,
        keywords: null
      },
      coverImages: [],
      detailImages: [],
      showDetailImages: [],
      maxGoodsPrice: 99999.99,
      goodsData: {
        id: '',
        title: '',
        cover: '',
        images: [],
        category: 0,
        price: '0.01',
        content: ''
      },
      goodsDialog: {
        showEditDialog: false,
        canEdit: true,
        prevImages: [],
        disabled: false
      },
      editor: null,
      toolbarConfig: { excludeKeys: ['group-video', 'insertImage'] },
      editorConfig: {
        placeholder: '请输入商品描述',
        MENU_CONF: {
          uploadImage: {
            server: '/mgr/image/upload',
            fieldName: 'file',
            meta: {
              type: 'detail'
            }
          }
        }
      }
    }
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    formatPrice () {
      this.goodsData.price = parseFloat(this.goodsData.price).toFixed(2)
      if (this.goodsData.price > this.maxGoodsPrice) {
        this.$message.error('价格不得超过' + this.maxGoodsPrice)
        this.goodsData.price = this.maxGoodsPrice
      }
    },
    onEditorCreate (editor) {
      this.editor = Object.seal(editor)
    },
    handleCoverRemove () {
      this.coverImages = []
    },
    handleDetailRemove (file) {
      for (let i in this.detailImages) {
        if (this.detailImages[i].url === file.url) {
          this.detailImages.splice(i, 1)
          break
        }
      }
      for (let i in this.showDetailImages) {
        if (this.showDetailImages[i].url === file.url) {
          this.showDetailImages.splice(i, 1)
          break
        }
      }
    },
    handleCoverSuccess (response) {
      this.coverImages = [{ url: response.data.url }]
    },
    handleDetailSuccess (response) {
      this.detailImages.push({ url: response.data.url })
    },
    uploadFileExceed () {
      this.$message.error('超出上传数量')
    },
    showGoodsEditDialog (goodsData, canEdit = true) {
      if (goodsData.id) {
        this.goodsData = goodsData
        this.detailImages = this.goodsData.images
        this.showDetailImages = this.goodsData.images
        this.coverImages = [{ url: this.goodsData.cover }]
        setTimeout(() => {
          this.editor.setHtml(goodsData.content)
        }, 100)
        this.goodsDialog.canEdit = canEdit
      }
      if (this.editor) {
        this.goodsDialog.canEdit ? this.editor.enable() : this.editor.disable()
      }
      let that = this
      setTimeout(function () {
        let body = document.querySelector('.detail-uploader .el-upload-list')
        Sortable.create(body, {
          onEnd ({ newIndex, oldIndex }) {
            const currRow = that.detailImages.splice(oldIndex, 1)[0]
            that.detailImages.splice(newIndex, 0, currRow)
            that.showDetailImages = that.detailImages
          }
        })
      }, 1000)
      this.goodsDialog.showEditDialog = true
    },
    hideGoodsEditDialog () {
      this.goodsData = {}
      this.goodsDialog.showEditDialog = false
      this.detailImages = []
      this.showDetailImages = []
      this.coverImages = []
      this.editor.setHtml('')
      this.goodsDialog.canEdit = true
    },
    updateGoodsList () {
      let that = this
      this.pageData = {}
      MilkRequestUtil.queryGoodsList({ queryParam: this.queryParam }, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    loadCategorys () {
      let that = this
      MilkRequestUtil.queryCategoryList({}, function (response) {
        that.categorys = response
      })
    },
    onAuditStateChange (item) {
      this.queryParam.page = 1
      this.queryParam.status = parseInt(item.selectValue)
      this.updateGoodsList()
    },
    onCategoryChange (item) {
      this.queryParam.page = 1
      this.queryParam.category = parseInt(item.selectValue)
      this.updateGoodsList()
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateGoodsList()
    },
    view (param) {
      this.showGoodsEditDialog(param, param.status === 2)
    },
    edit (param) {
      this.showGoodsEditDialog(param)
    },
    up (param) {
      MessageUtil.tipsConfirm('确认上架此商品？', 'warning', () => {
        MilkRequestUtil.upGoods(param, this.updateGoodsList)
      })
    },
    down (param) {
      MessageUtil.tipsConfirm('确认下架此商品？', 'warning', () => {
        MilkRequestUtil.downGoods(param, this.updateGoodsList)
      })
    },
    remove (param) {
      MessageUtil.tipsConfirm('确认删除此商品？', 'warning', () => {
        MilkRequestUtil.removeGoods(param, this.updateGoodsList)
      })
    },
    batchUp () {
      MessageUtil.tipsConfirm('确认上架选中的商品？', 'warning', () => {
        MilkRequestUtil.upGoods({ id: this.params.ids }, this.updateGoodsList)
      })
    },
    batchDown () {
      MessageUtil.tipsConfirm('确认下架选中的商品？', 'warning', () => {
        MilkRequestUtil.downGoods({ id: this.params.ids }, this.updateGoodsList)
      })
    },
    batchRemove () {
      let that = this
      MessageUtil.tipsConfirm('确认删除选中的商品？', 'warning', () => {
        MilkRequestUtil.removeGoods({ id: this.params.ids }, (response) => {
          this.$message.success('操作成功，' + response.result.success + '个成功删除，' + response.result.failed + '个删除失败')
          that.updateGoodsList()
        })
      })
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateGoodsList()
    },
    saveGoods () {
      let that = this
      this.goodsData.cover = this.coverImages[0].url
      this.goodsData.images = this.detailImages
      this.goodsData.content = this.editor.getHtml()
      if (!this.goodsData.cover) {
        return this.$message.error('封面不能为空')
      }
      if (!this.goodsData.images) {
        return this.$message.error('商品图片不能为空')
      }
      if (!this.goodsData.content) {
        return this.$message.error('商品内容不能为空')
      }
      if (this.goodsData.price > this.maxGoodsPrice) {
        return this.$message.error('商品价格不能超过' + this.maxGoodsPrice)
      }
      this.goodsDialog.disabled = true
      MilkRequestUtil.saveGoodsInfo(this.goodsData, (response) => {
        if (response.result) {
          this.$message.success('操作成功')
          that.updateGoodsList()
          that.hideGoodsEditDialog()
        }
        that.goodsDialog.disabled = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.box-card {
  margin-bottom: 10px;

  .title {
    font-weight: bold;
  }

  .cover-uploader.disabled, .detail-uploader.disabled {
    /deep/ .el-upload--picture-card {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/milk/goods/MilkGoodsListPage.vue